import { DATASET_CONTROL_DATA_PARAM } from '../../constants';
import { JSONObject } from '../../types/types';
import { isPlainJsonObject } from './isPlainJsonObject';

// 'unparseable' — the param is not valid JSON at all;
// 'badShape' — valid JSON, but not an object (the datasetControl property
// must be an object for apiMethod JSONata expressions to read from).
export type DatasetControlDataMalformedReason = 'unparseable' | 'badShape';

export type ParsedDatasetControlData =
  | { raw: string; data: JSONObject }
  | { raw: string; malformed: true; reason: DatasetControlDataMalformedReason }
  | null;

// Reads the dataset control data param. Returns null when absent; the raw
// value is kept so the caller can restore the param into rebuilt URLs
// verbatim.
export const parseDatasetControlData = (
  search: string
): ParsedDatasetControlData => {
  const raw = new URLSearchParams(search).get(DATASET_CONTROL_DATA_PARAM);
  if (raw === null) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (!isPlainJsonObject(parsed)) {
      return { raw, malformed: true, reason: 'badShape' };
    }

    return { raw, data: parsed };
  } catch {
    return { raw, malformed: true, reason: 'unparseable' };
  }
};
